import type * as Types from '@hotelplan/supergraph-api';

import type { DocumentNode } from 'graphql';
import { FdrProductRecommenderAdventureTravelFragmentDoc } from 'schemas/fragment/recommenders/product/fdr-product-recommender.generated';
import type * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@hotelplan/fdr.lib.apollo.query';
const defaultOptions = {} as const;
export type FdrProductRecommendedProductsQueryVariables = Types.Exact<{
  input: Types.FdrProductInput;
  productsInput: Types.FdrGeoProductsInput;
}>;

export type FdrProductRecommendedProductsQuery = {
  __typename?: 'Query';
  fdrProduct?:
    | {
        __typename: 'FdrAdventureTravel';
        startingDestination: {
          __typename?: 'FdrDestination';
          country: {
            __typename?: 'FdrCountry';
            name: string;
            products: {
              __typename?: 'FdrGeoProducts';
              productsPage?: Array<
                | {
                    __typename: 'FdrAdventureTravel';
                    name: string;
                    teaser: string;
                    id: string;
                    bookmarked: boolean;
                    images?: Array<{
                      __typename?: 'FdrImage';
                      alt: string;
                      description?: string | null;
                      copyright?: string | null;
                      rawUrl: string;
                      resized: Array<{
                        __typename?: 'FdrResizedImage';
                        id: string;
                        link: {
                          __typename?: 'FdrLink';
                          openMethod?: Types.FdrLinkOpenMethod | null;
                          legacyUrl?: string | null;
                          type: Types.FdrLinkType;
                          url: string;
                        };
                      }>;
                    }> | null;
                    disrupters?: Array<{
                      __typename?: 'FdrDisrupter';
                      text: string;
                      bgColor?: string | null;
                      fgColor?: string | null;
                    }> | null;
                    route?: Array<{
                      __typename?: 'FdrAdventureTravelRoutePoint';
                      locationName: string;
                      coordinates: {
                        __typename?: 'FdrCoordinates';
                        latitude: number;
                        longitude: number;
                      };
                    }> | null;
                    webMeta: {
                      __typename?: 'FdrProductWebMeta';
                      descriptionWebMeta?: {
                        __typename?: 'FdrMeta';
                        link: {
                          __typename?: 'FdrLink';
                          openMethod?: Types.FdrLinkOpenMethod | null;
                          legacyUrl?: string | null;
                          type: Types.FdrLinkType;
                          url: string;
                        };
                      } | null;
                    };
                    featureGroups?: Array<{
                      __typename?: 'FdrProductFeatureGroup';
                      id: string;
                      name: string;
                      features: Array<{
                        __typename?: 'FdrProductFeature';
                        id: string;
                        name: string;
                        enabled: boolean;
                      }>;
                    }> | null;
                  }
                | { __typename: 'FdrCruise' }
                | { __typename: 'FdrHotel' }
                | { __typename: 'FdrRoundTrip' }
              > | null;
            };
          };
        };
      }
    | { __typename: 'FdrCruise' }
    | { __typename: 'FdrHotel' }
    | { __typename: 'FdrRoundTrip' }
    | null;
};

export const FdrProductRecommendedProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FdrProductRecommendedProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FdrProductInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'productsInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FdrGeoProductsInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fdrProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrAdventureTravel' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startingDestination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'country' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'name' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'products' },
                                    arguments: [
                                      {
                                        kind: 'Argument',
                                        name: { kind: 'Name', value: 'input' },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productsInput',
                                          },
                                        },
                                      },
                                    ],
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'productsPage',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: '__typename',
                                                },
                                              },
                                              {
                                                kind: 'FragmentSpread',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'fdrProductRecommenderAdventureTravel',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...FdrProductRecommenderAdventureTravelFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;

/**
 * __useFdrProductRecommendedProductsQuery__
 *
 * To run a query within a React component, call `useFdrProductRecommendedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFdrProductRecommendedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFdrProductRecommendedProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      productsInput: // value for 'productsInput'
 *   },
 * });
 */
export function useFdrProductRecommendedProductsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FdrProductRecommendedProductsQuery,
    FdrProductRecommendedProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    FdrProductRecommendedProductsQuery,
    FdrProductRecommendedProductsQueryVariables
  >(FdrProductRecommendedProductsDocument, options);
}
export function useFdrProductRecommendedProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FdrProductRecommendedProductsQuery,
    FdrProductRecommendedProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    FdrProductRecommendedProductsQuery,
    FdrProductRecommendedProductsQueryVariables
  >(FdrProductRecommendedProductsDocument, options);
}
export type FdrProductRecommendedProductsQueryHookResult = ReturnType<
  typeof useFdrProductRecommendedProductsQuery
>;
export type FdrProductRecommendedProductsLazyQueryHookResult = ReturnType<
  typeof useFdrProductRecommendedProductsLazyQuery
>;
export type FdrProductRecommendedProductsQueryResult = Apollo.QueryResult<
  FdrProductRecommendedProductsQuery,
  FdrProductRecommendedProductsQueryVariables
>;
